import { css, keyframes } from "@emotion/react";

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const spinnerStyle = css`
  width: 48px;
  height: 48px;
  border: 4px solid var(--border-default);
  border-top-color: var(--accent);
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const containerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

interface SpinnerProps {
  /** Render fullscreen centered (default: true) */
  fullscreen?: boolean;
  /** Custom size in pixels */
  size?: number;
}

export function Spinner({ fullscreen = true, size = 48 }: SpinnerProps) {
  const spinner = (
    <div
      css={[
        spinnerStyle,
        size !== 48 && { width: size, height: size },
      ]}
      role="status"
      aria-label="Loading"
    />
  );

  if (fullscreen) {
    return <div css={containerStyle}>{spinner}</div>;
  }

  return spinner;
}
